import _ from 'lodash';
import { EnvironmentDefaults } from './environment.constants';

export const Environment = {
  defaults: EnvironmentDefaults,
  create,
};

/**
 *  Exports the current environment which defines the tenant,
 *  the customization, and the stage. All these values are defined
 *  by the location hostname and therefore needs to be parsed.
 *
 *  The location hostname can be:
 *  [tenant-name][-stage].host.tld
 *  [tenant-name][.stage].host.tld
 */
function create(config, defaults = {}, overwrites = {}) {
  const { custom, stages, baseUrl, build } = config;

  const customNames = _.values(custom);
  const stageNames = _.values(stages);

  // Overwrite defaults
  defaults = _.merge({}, defaults, EnvironmentDefaults);

  const host = window.location.hostname; // eslint-disable-line angular/window-service
  const hostParts = host.split('.');

  // Get stage defined by the host
  let hostStage = _.find(stageNames, (e) => _.includes(hostParts[1], e));

  const hostPart = cleanFromStageName(hostParts[0]);

  // Get tenant defined by the host
  const hostTenant = hostPart;

  // Get customization defined by the host
  let hostCustomization = _.find(customNames, (e) => _.includes(hostPart, e));

  if (overwrites.customPath) {
    hostCustomization = overwrites.customPath;
  }

  return _.merge(
    {
      tenant: hostTenant || defaults.tenant,
      custom: hostCustomization || defaults.custom,
      stage: hostStage || defaults.stage,
      baseUrl: baseUrl || defaults.baseUrl,
      build: build || defaults.build,
    },
    overwrites
  );

  function cleanFromStageName(tenant) {
    if (_.includes(tenant, hostStage)) {
      return tenant.replace('-' + hostStage, '');
    }
    return tenant;
  }
}



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-environment/src/environment.js